export default "__VITE_ASSET__75cff64d__"